import Http from './base-http'

class Request extends Http {
  deleteRequest(data) {
    return this.client.delete(`Request/${data.id}`)
  }
}

const requests = new Request({
  modelUrlPrefix : ''
})

export default requests
